import React from "react";
import { Row, Button, Modal, Col } from "react-bootstrap";
import {
  editContactAction,
  getContactByIdAction,
  getUserRolesAction,
  addUserRolesAction,
  CheckEmailOrMobileUnique,
  editContactActionNew,
  getUserRolesActionNew,
  CheckEmailOrMobileUniqueatAddContact,
  updateClientAction,
} from "../../actions/UserActions";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Field, Form, Formik, ErrorMessage } from "formik";
import InputMask from "react-input-mask";
import { cryptoTokenDecode, checkObjExists } from "./../Common/Common";
import * as message from "./../../config/CommonMessages";
import UrlConstants from "../../config/UrlConstants";
import { HexColorInput, HexColorPicker } from "react-colorful";
import APIUtil from "./../../config/APIUtil";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { UploadFile } from "@mui/icons-material";
import { withRouter } from "react-router-dom";

class EditContact extends React.Component {
  constructor(props) {
    super(props);

    let userType = cryptoTokenDecode().usertype;

    this.state = {
      userType: userType.toUpperCase(),
      isEmailValid: false,
      unauthorized: false,
      roleForPopup: this.props.roleForPopup,
      roleIdForPopup: this.props.roleIdForPopup,
      contact: {
        role: "",
        usertype: "",
        firstname: "",
        lastname: "",
        mobileNumber: "",
        email: "",
        color: "",
        showLoader: false,
        allowPublicProfile: false,
        allowPublicScheduling: false,
        isTextMsgEnabled: false,
      },
      emailUnauthorized: false,
      mobileUnauthorized: false,
      editable: false,
      emailExists: false,
      allowPublicSchedulingErr: false,
      allowPublicProfileUrlErr: false,
    };
  }

  checkUserData() {
    // console.log("this.props.contactData", this.props.contactData);
    return this.props.contactData &&
      this.props.contactData.UserData &&
      this.props.contactData.UserData.length > 0 &&
      this.props.contactData.UserData[0]
      ? true
      : false;
  }

  checkDsdData(res) {
    let ownerId =
      localStorage.getItem("usertype") === "VENDOR"
        ? localStorage.getItem("ownerId")
        : localStorage.getItem("ID");
    let foundOwner = {};
    if (res && res.dsd && res.dsd.studios && res.dsd.studios.length > 0) {
      foundOwner = res.dsd.studios.filter((item) => item.ownerId === ownerId);
    }
    // console.log("foundOwner", foundOwner[0]);
    return foundOwner[0];
  }

  checkDsdItemValue(foundOwner, item) {
    // console.log("checkDsdItemValue", foundOwner);
    // console.log(foundOwner.hasOwnProperty(item) ? foundOwner[item] : false);
    return foundOwner.hasOwnProperty(item) ? foundOwner[item] : false;
  }

  componentDidMount() {
    // console.log("previous component data 44", this.props.contactData);
    // console.log("roleIdForPopup", this.state.roleIdForPopup);
    let dataforEdit = {
      role: (this.props.contactData && this.props.contactData.roles) || [],
      usertype:
        (this.checkUserData() && this.props.contactData.UserData[0].usertype) ||
        "",
      firstname:
        (this.checkUserData() &&
          this.props.contactData.UserData[0].firstname) ||
        "",
      lastname:
        (this.checkUserData() && this.props.contactData.UserData[0].lastname) ||
        "",
      mobileNumber:
        this.checkUserData() &&
        this.props.contactData.UserData[0].mobileNumber === null
          ? ""
          : this.props.contactData.UserData[0].mobileNumber,
      email:
        this.checkUserData() &&
        this.props.contactData.UserData[0].email &&
        this.props.contactData.UserData[0].email.address
          ? this.props.contactData.UserData[0].email.address
          : "",
      color: this.props.contactData.color ? this.props.contactData.color : "",
      showLoader: false,
      allowPublicProfile:
        this.checkUserData() &&
        !!this.checkDsdData(this.props.contactData.UserData[0])
          ? this.checkDsdItemValue(
              this.checkDsdData(this.props.contactData.UserData[0]),
              "allowPublicProfile"
            )
          : false,
      allowPublicScheduling:
        this.checkUserData() &&
        !!this.checkDsdData(this.props.contactData.UserData[0])
          ? this.checkDsdItemValue(
              this.checkDsdData(this.props.contactData.UserData[0]),
              "allowPublicScheduling"
            )
          : false,
      isTextMsgEnabled:
        this.props.contactData.UserData[0] &&
        this.props.contactData.UserData[0].dsd && 
        this.props.contactData.UserData[0].dsd.isTextMsgEnabled,
    };
    // console.log("dataforEdit");
    this.setState({ contact: dataforEdit });

    let prevEmail =
      this.props.contactData.UserData[0].email &&
      this.props.contactData.UserData[0].email.address
        ? this.props.contactData.UserData[0].email.address
        : "";
    this.setState({ emailExists: prevEmail ? true : false });
    // this.props
    //   .getContactByIdAction(this.props.contactData._id)
    //   .then((res) => {
    //     console.log("response", res);
    //     console.log("this.props.contact", this.props.contact);
    //     this.setState({ editable: this.props.contact.isPasswordSet });
    //     this.setState({ contact: this.props.contact });
    //     this.setState({
    //       showLoader: false,
    //     });
    //   })
    //   .catch((err) => {});
  }

  next() {
    this.setState({
      page: 1,
    });
  }

  checkEmailValidation(value) {
    APIUtil.getMethod(
      UrlConstants.addContact +
        "/CheckEmailOrMobileUniqueatregistration?email=" +
        value +
        "&id=" +
        this.props.contactData.contactId,
      false
    ).then((res) => {
      if (res.data.error === "Unauthorized") {
        this.setState({ emailUnauthorized: true });
      } else {
        this.setState({ emailUnauthorized: false });
      }
    });
  }

  checkMobileValidation(value) {
    let mob = value.replace(/-/g, "");
    if (mob.length === 10) {
      APIUtil.getMethod(
        UrlConstants.addContact +
          "/CheckEmailOrMobileUniqueatregistration?mobile=" +
          mob +
          "&id=" +
          this.props.contactData.contactId,
        false
      ).then((res) => {
        if (res.data.error === "Unauthorized") {
          this.setState({ mobileUnauthorized: true });
        } else {
          this.setState({ mobileUnauthorized: false });
        }
      });
    }
  }

  checkValidationsAndSubmit(values, errors) {
    // console.log("checkValidationsAndSubmit values", values);
    let mobile = values["mobileNumber"];
    // let email = values["email"];
    // let ccEmail = values["ccEmail"];
    // if (
    //   email !== "" &&
    //   ccEmail !== "" &&
    //   errors["email"] === undefined &&
    //   errors["ccEmail"] === undefined
    // ) {
    //   if (email === ccEmail) {
    //     this.setState({ ccEmailInvalid: true });
    //   } else {
    //     this.setState({ ccEmailInvalid: false });
    //   }
    // }

    // APIUtil.getMethod(
    //   UrlConstants.addContact +
    //     "/CheckEmailOrMobileUniqueatregistration?mobile=" +
    //     mobile +
    //     "&id=" +
    //     this.props.contactData.contactId,
    //   false
    // ).then((res) => {
    //   if (res.data.error === "Unauthorized") {
    //     this.setState({ mobileUnauthorized: true });
    //   } else {
    //     this.setState({ mobileUnauthorized: false });
    //   }

    //   if (!this.state.mobileUnauthorized) {
    //     this.updateContact(values);
    //   }
    // });

    if (
      !this.state.mobileUnauthorized &&
      !this.state.emailUnauthorized &&
      !this.state.allowPublicProfileUrlErr &&
      !this.state.allowPublicSchedulingErr
    ) {
      this.updateContact(values);
    }
  }

  checkPublicProfileUrl(values, setFieldValue, item, itemValue) {
    if (!values.allowPublicProfile) {
      if (itemValue) {
        this.setState({
          allowPublicSchedulingErr: true,
          allowPublicProfileUrlErr: false,
        });
      } else {
        setFieldValue(item, itemValue);
        this.setState({
          allowPublicSchedulingErr: false,
          allowPublicProfileUrlErr: false,
        });
      }
    } else {
      setFieldValue(item, itemValue);
      this.setState({
        allowPublicSchedulingErr: false,
        allowPublicProfileUrlErr: false,
      });
    }
  }

  checkPublicScheduling(values, setFieldValue, item, itemValue) {
    if (values.allowPublicScheduling) {
      if (!itemValue) {
        this.setState({
          allowPublicProfileUrlErr: true,
          allowPublicSchedulingErr: false,
        });
      } else {
        setFieldValue(item, itemValue);
        this.setState({
          allowPublicProfileUrlErr: false,
          allowPublicSchedulingErr: false,
        });
      }
    } else {
      setFieldValue(item, itemValue);
      this.setState({
        allowPublicProfileUrlErr: false,
        allowPublicSchedulingErr: false,
      });
    }
  }

  /**
   * @desc update contact details
   * check if user selected custom role then first add that role using api
   * and then add user/contact with details by add contact api
   */
  updateContact(values) {
    this.setState({
      showLoader: true,
    });
    var dataToPut = {
      roles: [this.state.roleIdForPopup ? this.state.roleIdForPopup._id : ""],
      default: values.default,
      firstname: values.firstname,
      lastname: values.lastname,
      email: values.email,
      mobileNumber: values.mobileNumber,
      isPasswordSet: values.isPasswordSet,
      color: values.color,
      ownerId:
        cryptoTokenDecode().usertype === message.ACCTOWNER
          ? localStorage.getItem("ID")
          : localStorage.getItem("ownerId"),
      allowPublicProfile: values.allowPublicProfile
        ? values.allowPublicProfile
        : false,
      allowPublicScheduling: values.allowPublicScheduling
        ? values.allowPublicScheduling
        : false,
      isTextMsgEnabled: values.isTextMsgEnabled,
    };

    this.state.roleForPopup === "Artist"
      ? this.props
          .editContactActionNew(dataToPut, this.props.contactData._id)
          .then((res) => {
            this.setState({
              showLoader: false,
            });
            this.props.onClose();
          })
      : this.props
          .updateClientAction(dataToPut, this.props.contactData._id)
          .then((res) => {
            this.setState({
              showLoader: false,
            });
            this.props.onClose();
          });
  }

  /**
   * check email or mobile is unique or not
   * @param {*} name
   * @param {*} e
   */
  async checkDuplicate(values, errors) {
    this.setState({
      unauthorized: false,
      emailUnauthorized: false,
      mobileUnauthorized: false,
    });
    // console.log("id", this.props.contactData.contactId);
    let flag = false;
    // console.log("flag 1===============>", flag);
    // console.log("check", values);
    if (
      values.email != "" &&
      errors["email"] == undefined &&
      values.mobileNumber == ""
    ) {
      // console.log("i am here 114", values.email);
      await this.props
        .CheckEmailOrMobileUniqueatAddContact(
          values.email,
          undefined,
          this.props.contactData.contactId
        )
        .then((res) => {
          // console.log("response", res);
          if (
            res.error == "Unauthorized" &&
            this.props.contactData.contactId != res.data._id
          ) {
            // console.log("i am here 123", values.email);
            if (res.data.email == 1) {
              this.setState({
                emailUnauthorized: true,
              });
            }
            if (res.data.mobile == 1)
              this.setState({
                mobileUnauthorized: true,
              });
            flag = true;
            // console.log("flag 2===============>", flag);
          }
        });
    } else if (
      values.mobileNumber != "" &&
      errors["mobileNumber"] == undefined &&
      values.email == ""
    ) {
      await this.props
        .CheckEmailOrMobileUniqueatAddContact(
          undefined,
          values.mobileNumber,
          this.props.contactData.contactId
        )
        .then((res) => {
          if (
            res.error == "Unauthorized" &&
            this.props.contactData.contactId != res.data._id
          ) {
            this.setState({
              unauthorized: true,
            });
            if (res.data.email == 1) {
              this.setState({
                emailUnauthorized: true,
              });
            }
            if (res.data.mobile == 1)
              this.setState({
                mobileUnauthorized: true,
              });
            flag = true;
            // console.log("flag 3===============>", flag);
          }
        });
    } else {
      //  console.log(
      //   "this.props.contactData.contactId",
      //   this.props.contactData.contactId
      // );
      // console.log("else condition");
      await this.props
        .CheckEmailOrMobileUniqueatAddContact(
          values.email,
          values.mobileNumber,
          this.props.contactData.contactId
        )
        .then((res) => {
          // console.log("res.data._id", res.data._id);
          if (
            res.error == "Unauthorized" &&
            this.props.contactData.contactId != res.data._id
          ) {
            this.setState({
              unauthorized: true,
            });
            if (res.data.email == 1) {
              this.setState({
                emailUnauthorized: true,
              });
            }
            if (res.data.mobile == 1)
              this.setState({
                mobileUnauthorized: true,
              });
            flag = true;
            // console.log("flag 4===============>", flag);
          }
        });
    }
    // console.log("flag 5===============>", flag);
    if (flag == false) {
      // call update api
      // console.log("call update api");
      this.updateContact(values);
    }
  }
  setFieldValue(name, e) {
    var contact = this.state.contact;
    contact[name] = e;
    this.setState({
      contact,
    });
  }
  setMobile(value, field, setFieldValue) {
    var mob = value.replace(/-/g, "");
    setFieldValue(field, mob);
  }

  handleColorAvailability(color, isColorUsed) {
    let contactColors = [];

    for (let i = 0; i < this.props.contacts.length; i++) {
      let contactColor = this.props.contacts[i].color;
      contactColors.push(contactColor);
      if (contactColors.includes(color)) {
        isColorUsed = true;
      } else {
        isColorUsed = false;
      }
    }

    return isColorUsed;
  }

  render() {
    return (
      <div>
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <Modal.Body>
          <Formik
            validateOnBlur={true}
            initialValues={this.state.contact}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              firstname: Yup.string()
                .trim()
                .required(message.ENTER_FIRST_NAME)
                .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                  message: message.ENTER_VALID_FIRST_NAME,
                }),
              lastname: Yup.string()
                .trim()
                .required(message.ENTER_LAST_NAME)
                .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                  message: message.ENTER_VALID_LAST_NAME,
                }),
              email: Yup.string()
                .trim()
                .matches(
                  new RegExp("^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"),
                  {
                    message: message.ENTER_VALID_EMAIL,
                  }
                )
                .required(message.ENTER_EMAIL),
              mobileNumber: Yup.string()
                .nullable()
                .required(message.ENTER_MOBILE_NUMBER)
                .test("mobileNumber", message.ENTER_VALID_MOBILE, (value) => {
                  // console.log("mobileNumber value", value);
                  if ((value || "").length === 10 && value.charAt(0) != "0") {
                    return true;
                  }
                  return false;
                }),
              isTextMsgEnabled: Yup.boolean(),
            })}
            onSubmit={(values, errors) => {
              // values.roles = document.getElementById("ddlRoles").value;
              // this.updateContact(values);
              // this.checkDuplicate(values, errors);
              // console.log("updateContact: ", values);

              this.checkValidationsAndSubmit(values, errors);
            }}
          >
            {({ handleChange, values, errors, setFieldValue }) => (
              <Form className="form-sm form-admin">
                <>
                  <div className="form-group">
                    <label>
                      Email<span className="text-danger"> *</span>
                    </label>

                    <Field
                      type="text"
                      className="form-control"
                      name="email"
                      value={values.email}
                      disabled={values.email && this.state.emailExists}
                      onChange={(e) => {
                        setFieldValue("email", e.target.value);
                        this.setState({
                          unauthorized: false,
                          emailUnauthorized: false,
                          mobileUnauthorized: false,
                        });
                      }}
                      onBlur={(e) => {
                        this.checkEmailValidation(e.target.value);
                      }}
                      // handleChange={handleChange}
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    />
                    {this.state.emailUnauthorized && values.email != "" ? (
                      <label
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      >
                        {message.EMAIL_EXISTS}
                      </label>
                    ) : (
                      ""
                    )}
                  </div>
                  {this.state.roleIdForPopup == undefined ? (
                    <select
                      className="form-control"
                      id="ddlRoles"
                      name="roles"
                      value={values.role}
                      onChange={(e) => {
                        setFieldValue("roles", e.target.value);
                      }}
                      style={{ display: "none" }}
                      disabled
                    >
                      {this.props.roles &&
                        this.props.roles
                          .filter((role) =>
                            this.props.roleForPopup === "Artist"
                              ? role.name === "Artist"
                              : role.name === "Client"
                          )
                          .map((role) => {
                            return (
                              <option value={role._id}>{role.name}</option>
                            );
                          })}
                    </select>
                  ) : (
                    <select
                      className="form-control"
                      id="ddlRoles"
                      name="roles"
                      value={this.state.roleIdForPopup}
                      onChange={(e) => {
                        setFieldValue("roles", e.target.value);
                      }}
                      style={{ display: "none" }}
                      disabled
                    >
                      <option value={this.state.roleIdForPopup}>
                        {this.state.roleForPopup}
                      </option>
                    </select>
                  )}

                  {/* <ErrorMessage
                      name="roles[0]"
                      component="div"
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    /> */}
                </>

                <div className="form-group">
                  <label>
                    First Name
                    {this.state.editable === false ? (
                      <span className="text-danger"> *</span>
                    ) : (
                      ""
                    )}
                  </label>
                  <Field
                    type="text"
                    name="firstname"
                    className="field_ucfirst form-control"
                    value={values.firstname}
                    handleChange={handleChange}
                  />
                  <ErrorMessage
                    name="firstname"
                    component="div"
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  />
                </div>
                <div className="form-group">
                  <label>
                    Last Name
                    {this.state.editable === false ? (
                      <span className="text-danger"> *</span>
                    ) : (
                      ""
                    )}
                  </label>
                  <Field
                    type="text"
                    name="lastname"
                    className="field_ucfirst form-control"
                    value={values.lastname}
                    // handleChange={handleChange}
                  />
                  <ErrorMessage
                    name="lastname"
                    component="div"
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  />
                </div>
                <div className="form-group">
                  <label>
                    Mobile Number
                    {this.state.editable === false ? (
                      <span className="text-danger"> *</span>
                    ) : (
                      ""
                    )}
                  </label>
                  <InputMask
                    mask="999-999-9999"
                    maskChar=""
                    formControlProps={{
                      fullWidth: true,
                    }}
                    className={`form-control ${
                      this.state.editable ? "disabled pointer-none" : ""
                    }`}
                    value={values.mobileNumber}
                    name="mobileNumber"
                    onChange={(e) => {
                      this.setMobile(
                        e.target.value,
                        "mobileNumber",
                        setFieldValue
                      );
                      this.setState({
                        unauthorized: false,
                        emailUnauthorized: false,
                        mobileUnauthorized: false,
                      });
                    }}
                    onBlur={(e) => {
                      this.checkMobileValidation(e.target.value);
                    }}
                  >
                    {(inputProps) => <Field {...inputProps} />}
                  </InputMask>
                  <ErrorMessage
                    name="mobileNumber"
                    component="div"
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  />
                  {this.state.mobileUnauthorized && values.mobileNumber !== "" && (
                    <label
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {message.MOBILE_NUMBER_EXISTS}
                    </label>
                  )}
                </div>
                {this.props.roleForPopup === "Client" && (
                  <div className="form-group">
                    <div className="custom-control custom-checkbox custom-control-inline custom-privacy mt-2">
                      <input
                        value={values.isTextMsgEnabled}
                        checked={values.isTextMsgEnabled}
                        type="checkbox"
                        className="custom-control-input green-checkbox"
                        id="isTextMsgEnabled"
                        name="isTextMsgEnabled"
                        onChange={(e) => {
                          setFieldValue("isTextMsgEnabled", e.target.checked);
                        }}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="isTextMsgEnabled"
                      >
                        Opted In to receive text Messages
                      </label>
                    </div>
                  </div>
                )}
                {this.props.roleForPopup === "Artist" ? (
                  <div>
                    <Row>
                      <Col xs={6}>
                        <div className="form-group">
                          <div className="form-check">
                            <label className="form-check-label">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                name="allowPublicProfile"
                                checked={values.allowPublicProfile}
                                onChange={(e) => {
                                  this.checkPublicScheduling(
                                    values,
                                    setFieldValue,
                                    "allowPublicProfile",
                                    e.target.checked
                                  );
                                }}
                              />
                              Allow Public Profile
                            </label>
                          </div>
                          {this.state.allowPublicProfileUrlErr && (
                            <label
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              Allow Public Scheduling is active.
                            </label>
                          )}
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="form-group">
                          <div className="form-check">
                            <label className="form-check-label">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                name="allowPublicScheduling"
                                checked={values.allowPublicScheduling}
                                onChange={(e) => {
                                  this.checkPublicProfileUrl(
                                    values,
                                    setFieldValue,
                                    "allowPublicScheduling",
                                    e.target.checked
                                  );
                                }}
                              />
                              Allow Public Scheduling
                            </label>
                          </div>
                          {this.state.allowPublicSchedulingErr && (
                            <label
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              Allow Public Profile is not checked.
                            </label>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <label>Choose a Color</label>
                    <Row className="ml-1 mb-4 mt-2">
                      <HexColorPicker
                        color={this.state.contact.color}
                        onChange={(e) => setFieldValue("color", e)}
                        style={{ width: "420px", height: "100px" }}
                      />
                    </Row>
                  </div>
                ) : (
                  ""
                )}
                {/* {this.state.userType === message.ACCTOWNER ? (
                  <div>
                    <Row className="ml-1 mb-4 mt-2">
                      <IconButton
                        onClick={() =>
                          this.props.history.push({
                            pathname: "/uploadPersonalDocuments",
                            state: {
                              id:
                                this.props.contactData &&
                                this.props.contactData.contactId,
                            },
                          })
                        }
                      >
                        <Tooltip title="Upload Personal Docs">
                          <UploadFile />
                        </Tooltip>
                      </IconButton>
                    </Row>
                  </div>
                ) : (
                  ""
                )} */}
                <Button
                  variant="primary"
                  size="sm"
                  className="btn-blue w-140"
                  type="submit"
                >
                  Update
                </Button>
              </Form>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contactResponse: state.reducer.contactResponse,
    contact: state.reducer.contact,
    roles: state.reducer.roles,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      editContactAction,
      getContactByIdAction,
      getUserRolesAction,
      addUserRolesAction,
      CheckEmailOrMobileUnique,
      editContactActionNew,
      getUserRolesActionNew,
      CheckEmailOrMobileUniqueatAddContact,
      updateClientAction,
    }
  )(EditContact)
);
